export default {
  title: 'Tedesco Autos Admin'
}
